import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-fly-out',
  templateUrl: './fly-out.component.html',
  styleUrls: ['./fly-out.component.css']
})
export class FlyOutComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle: string;
  @Input() width: string;
  @Input() noPadding: boolean;
  @Input() tabs = [];
  @Input() selectedTab = 0;

  @Output() close: EventEmitter<Event> = new EventEmitter();
  @Output() tabChange: EventEmitter<number> = new EventEmitter();


  constructor() {
  }

  ngOnInit() {
  }

  closeSideOverlay(event: Event = null) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.close.emit(event);
  }

  switchTab(tab: number) {
    this.selectedTab = tab;
    this.tabChange.emit(tab);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/fly-out/fly-out.component.ts